import React from 'react';
import {
  COLOR_BY_WIN_TYPE,
  ROUND_BET_TYPE_VIEW,
  ROUND_WIN_TYPE,
} from '../../../enums/betTypesEnum';

function StatisticItem({ item }) {
  return (
    <div className='sheet-b-inner-items'>
      <div
        className={`sheet-b-inner-oval ${
          item ? COLOR_BY_WIN_TYPE[ROUND_WIN_TYPE[item.winType]] : ''
        }`}
      >
        {item && item.isPairWin && (
          <span
            className={`sheet-b-inner-oval-item ${
              item.winType === ROUND_BET_TYPE_VIEW.PLAYER
                ? COLOR_BY_WIN_TYPE.PLAYER
                : COLOR_BY_WIN_TYPE.BANKER
            }`}
          />
        )}
      </div>
    </div>
  );
}

export default StatisticItem;
